<div *ngIf="loading" class="loading-shade">
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>
</div>
